<template>
  <div class="container">
    <googlemapBasic />
  </div>
</template>

<script>
import googlemapBasic from '@/components/googlemap.vue'
export default {
  name: 'index',
  components: {
    googlemapBasic
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
  }
};
</script>
<style lang="less">
</style>

